import { render, staticRenderFns } from "./CommandKGroup.vue?vue&type=template&id=42d39ea2&"
import script from "./CommandKGroup.vue?vue&type=script&lang=js&"
export * from "./CommandKGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports